import { Feature } from '../../shared/models/features';
import { LanguagesResources } from '../../shared/models/language-resources';
import deDE from '../assets/locales/de-DE/translation.json';
import enGB from '../assets/locales/en-GB/translation.json';
import { Language } from '../../shared/models/language';

export const translationNamespace = Feature.CORE;

export const resources: LanguagesResources = {
  [Language.EnglishGB]: {
    [translationNamespace]: enGB,
  },
  [Language.German]: {
    [translationNamespace]: deDE,
  },
};
